import { ComponentProps } from 'react'

import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export type ShowMoreTreeItemProps = ComponentProps<'div'>

export function ShowMoreTreeItem({
  className,
  ...props
}: ShowMoreTreeItemProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 text-sm text-content-subdued w-full',
        className,
      )}
      {...props}
    >
      <SvgIcon name="chevron-down" />
      <T id="Generics.ShowMore" defaultMessage="Show more" />
    </div>
  )
}
